import React, { useCallback, useEffect, useState } from 'react';
import { Row, Card, Radio, Button, Divider } from 'antd';
import SearchBar from '../../flights/landingpage/SearchBar';
import { useLocation, useNavigate } from 'react-router-dom';
import ImageChange from './ImageChange';
import dayjs from 'dayjs';
import { getFlightBanners } from '../../../services/flight/flightServices';

const SearchFlights = () => {
  const navigate = useNavigate()
  const dateFormat = 'DD/MMM/YYYY';
  const currentFormattedDate = dayjs().add(1, 'day').format(dateFormat);
  const nextDay = dayjs().add(2, 'day').format(dateFormat);
  const [findDay, setFindDay] = useState(currentFormattedDate);
  const [findDayRetrun, setFindDayRetrun] = useState(nextDay);

  const [showPrevDateIcon, setShowPrevDateIcon] = useState(null)
  const [selectAdults, setSelectAdults] = useState(1);
  const [selectchildren, setSelectchildren] = useState(0);
  const [selectInfants, setSelectInfants] = useState(0)
  const location = useLocation();
  const [returnFlight, setReturnFlight] = useState("oneWay")
  const [returnFlightComp, setReturnFlightComp] = useState(false);
  const [seatType, setSeatType] = useState("ECONOMY")

  const [errorSameCitySelect, setErrorSameCitySelect] = useState(false)
  const [selectedFrom, setSelectedFrom] = useState("");
  const [selectedTo, setSelectedTo] = useState("");
  const [showSearchListFrom, setShowSearchListFrom] = useState(false);
  const [infantsError, setInFantError] = useState(null)
  const [showSearchListTo, setShowSearchListTo] = useState(false);
  const [topCityData, setTopCityData] = useState(true);
  const [selectFromCity, setselectFromCity] = useState('')
  const [selectFromCityName, setselectFromCityName] = useState('')

  const [selectTOCity, setselectTOCity] = useState('')
  const [selectTOCityName, setselectTOCityName] = useState('')

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(currentFormattedDate);
  const [selectedReturnDate, setSelectedReturnDate] = useState(null);
  const [searchTermFrom, setSearchTermFrom] = useState("");
  const [searchTermTo, setSearchTermTo] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [validationError, setValidationError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({
    from: { hasError: false, message: '' },
    to: { hasError: false, message: '' }
  });

  const showValidationError = () => {
    setFieldErrors({
      from: { hasError: false, message: '' },
      to: { hasError: false, message: '' }
    });
    setValidationError('');

    if (!selectedFrom?.cityCode && !selectedTo?.cityCode) {
      setValidationError('Please select departure and arrival cities');
      setFieldErrors({
        from: { hasError: true, message: '' },
        to: { hasError: true, message: '' }
      });
    } else if (!selectedFrom?.cityCode) {
      setFieldErrors({
        from: { hasError: true, message: 'Please select departure city' },
        to: { hasError: false, message: '' }
      });
    } else if (!selectedTo?.cityCode) {
      setFieldErrors({
        from: { hasError: false, message: '' },
        to: { hasError: true, message: 'Please select arrival city' }
      });
    } else if (selectedFrom?.cityCode === selectedTo?.cityCode) {
      setFieldErrors({
        from: { hasError: true, message: 'Source and destination cannot be the same' },
        to: { hasError: true, message: 'Source and destination cannot be the same' }
      });
    }
  };

  const handleSelectFromFlight = (flight) => {
    if (flight.cityCode === selectedTo?.cityCode) {
      setErrorSameCitySelect(true);
      setFieldErrors({
        from: { hasError: true, message: 'Source and destination cannot be the same' },
        to: { hasError: true, message: 'Source and destination cannot be the same' }
      });
      return;
    }

    // Clear errors when valid selection is made
    setValidationError('');
    setErrorSameCitySelect(false);
    setFieldErrors({
      from: { hasError: false, message: '' },
      to: { hasError: false, message: '' }
    });

    setSearchTermFrom(flight.city);
    setSelectedFrom(flight);
    setselectFromCity(flight?.city);
    setselectFromCityName(flight?.name);
    setShowSearchListFrom(false);
    setTopCityData(true)
    setShowSearchListTo(true);
  };

  const handleSelectToFlight = (flight) => {
    if (flight.cityCode === selectedFrom?.cityCode) {
      setErrorSameCitySelect(true);
      setFieldErrors({
        from: { hasError: true, message: 'Source and destination cannot be the same' },
        to: { hasError: true, message: 'Source and destination cannot be the same' }
      });
      return;
    }
    setValidationError('');
    setErrorSameCitySelect(false);
    setFieldErrors({
      from: { hasError: false, message: '' },
      to: { hasError: false, message: '' }
    });

    setSearchTermTo(flight.city);
    setSelectedTo(flight);
    setselectTOCity(flight?.city);
    setselectTOCityName(flight?.name);
    setShowSearchListTo(false);
    setTopCityData(false);
  };

  const addAdults = () => {
    if (selectAdults < 10) {
      setSelectAdults((prevAdults) => {
        const newAdults = prevAdults + 1;
        if (selectInfants <= newAdults) {
          setInFantError(false);
        }
        return newAdults;
      });
    }
  };

  const removeAdults = () => {
    if (selectAdults > 1) {
      setSelectAdults((prevAdults) => {
        const newAdults = prevAdults - 1;
        if (selectInfants > newAdults) {
          setInFantError(true);
        } else {
          setInFantError(false);
        }
        return newAdults;
      });
    }
  };

  const addInfants = () => {
    setSelectInfants((prevSelectInfants) => {
      const newSelectInfants = prevSelectInfants + 1;
      if (newSelectInfants > selectAdults) {
        setInFantError(true);
      } else {
        setInFantError(false);
      }
      return newSelectInfants;
    });
  };

  const removeInfants = () => {
    setSelectInfants((prevSelectInfants) => {
      if (prevSelectInfants > 0) {
        const newSelectInfants = prevSelectInfants - 1;
        if (newSelectInfants > selectAdults) {
          setInFantError(true);
        } else {
          setInFantError(false);
        }
        return newSelectInfants;
      }
      return prevSelectInfants;
    });
  };

  const addChildern = () => {
    if (selectchildren < 10) {
      setSelectchildren(selectchildren + 1);
    }
  }

  const removeChildern = () => {
    if (selectchildren > 0) {
      setSelectchildren(selectchildren - 1);
    }
  }

  const onChangeTrip = (e) => {
    const { value } = e.target;
    setReturnFlight(value);
    setReturnFlightComp(true);
  };

  const roundTrip = () => {
    setReturnFlight("roundTrip");
    setReturnFlightComp(true);
  };

  const crossReturnDate = () => {
    setReturnFlight("oneWay");
    setReturnFlightComp(false);
  }


  const fetchOneWayFlight = useCallback(() => {
    if (!selectedFrom?.cityCode || !selectedTo?.cityCode || selectedFrom?.cityCode === selectedTo?.cityCode) {
      showValidationError();
      return;
    }

    setValidationError('');
    setFieldErrors({
      from: { hasError: false, message: '' },
      to: { hasError: false, message: '' }
    });
    sessionStorage.setItem('selectFromCity', JSON.stringify(selectFromCity));
    sessionStorage.setItem('selectFromCityName', JSON.stringify(selectFromCityName));
    sessionStorage.setItem('selectTOCity', JSON.stringify(selectTOCity));
    sessionStorage.setItem('selectTOCityName', JSON.stringify(selectTOCityName));
    sessionStorage.setItem('DepartureFlight', JSON.stringify(findDay));
    sessionStorage.setItem('selectAdultsflight', JSON.stringify(selectAdults));
    sessionStorage.setItem('selectChildflight', JSON.stringify(selectchildren));
    sessionStorage.setItem('selectInfantsflight', JSON.stringify(selectInfants));
    sessionStorage.setItem('seatTypeflight', JSON.stringify(seatType));
    sessionStorage.setItem('returnFlight', JSON.stringify(returnFlight));
    sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
    const formattedFromCity = selectedFrom?.city?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = selectedTo?.city?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    const resultUrl = `/flights/${urlIdDynamic}`;
    navigate(resultUrl);
  }, [selectFromCity, selectFromCityName, selectTOCity, selectTOCityName, findDay, selectAdults, selectchildren, selectInfants, seatType, returnFlight, findDayRetrun, selectedFrom, selectedTo, navigate]);

  useEffect(() => {
    if (!selectedFrom?.cityCode || !selectedTo?.cityCode) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [selectedFrom, selectedTo]);

  const fetchRoundCityFlights = useCallback(() => {
    if (!selectedFrom?.cityCode || !selectedTo?.cityCode || selectedFrom?.cityCode === selectedTo?.cityCode) {
      showValidationError();
      return;
    }

    setValidationError('');
    setFieldErrors({
      from: { hasError: false, message: '' },
      to: { hasError: false, message: '' }
    });
    sessionStorage.setItem('selectFromCity', JSON.stringify(selectFromCity));
    sessionStorage.setItem('selectFromCityName', JSON.stringify(selectFromCityName));
    sessionStorage.setItem('selectTOCity', JSON.stringify(selectTOCity));
    sessionStorage.setItem('selectTOCityName', JSON.stringify(selectTOCityName));
    sessionStorage.setItem('DepartureFlight', JSON.stringify(findDay));
    sessionStorage.setItem('selectAdultsflight', JSON.stringify(selectAdults));
    sessionStorage.setItem('selectChildflight', JSON.stringify(selectchildren));
    sessionStorage.setItem('selectInfantsflight', JSON.stringify(selectInfants));
    sessionStorage.setItem('seatTypeflight', JSON.stringify(seatType));
    sessionStorage.setItem('returnFlight', JSON.stringify(returnFlight));
    sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
    const formattedFromCity = selectedFrom?.city?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = selectedTo?.city?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    const resultUrl = `/flights/${urlIdDynamic}`;
    navigate(resultUrl);
  }, [selectFromCity, selectFromCityName, selectTOCity, selectTOCityName, findDay, selectAdults, selectchildren, selectInfants, seatType, returnFlight, findDayRetrun, selectedFrom, selectedTo, navigate]);

  const [Banners, setBanners] = useState(null)
  const [loading, setLoading] = useState(false);

  const fetchFlightBanners = async () => {
    try {
      setLoading(true);
      const response = await getFlightBanners();
      setBanners(response?.data || response || []);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFlightBanners()
  }, [])

  const [randomBanner, setRandomBanner] = useState(null);

  useEffect(() => {
    if (Banners?.sub_banners?.length > 0) {
      const randomIndex = Math?.floor(Math.random() * Banners?.sub_banners.length);
      setRandomBanner(Banners?.sub_banners[randomIndex]);
    }
  }, [Banners]);



  return (
    <section className={location?.pathname !== "/result-page" ? "head-box-cntr" : "head-box-cntr-result"} >
      
      {/* --- Banner Background --- */}
      <picture>
        <source
          srcSet={
            Banners?.original_url && Banners?.banner_image_url
              ? Banners?.original_url + Banners?.banner_image_url
              : "/images/flight-video-img.avif"
          }
          type="image/avif" />
        <img
          src={
            Banners?.original_url && Banners?.banner_image_url
              ? Banners?.original_url + Banners?.banner_image_url
              : "/images/flight-video-img.avif"
          }
          className="banner_background"
          alt={Banners?.title}
          loading="eager"
          fetchpriority="high"
          decoding="async"
          height="500"
        // style={{
        //   width: '100%',
        //   height: 'auto',
        //   position: 'relative',
        //   zIndex: 1
        // }}
        />
      </picture>
      
      {/* --- Content Container --- */}
      <div className="Banner_cntr">
        <div className="container">
          <Row gutter={16} className='w-100 justify-content-center m-0 d-block'>
            <Card className='position-relative'>
              <div className="kandil d-md-block d-none">
                <div className="kandil-top"></div>
                <div className="kandil-inner">
                  <div className="kandil-hang"></div>
                  <div className="kandil-left"></div>
                  <div className="kandil-right"></div>
                  <div className="kandil-bottom"></div>
                </div>

                <ul className="ribbons">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <span className="card_header_img">
                {randomBanner && randomBanner?.image_url && randomBanner?.sub_banner_image ? (
                  <img
                    src={`${randomBanner.image_url}${randomBanner.sub_banner_image}`}
                    alt="Sub Banner"
                    className="destination-update"
                  />
                ) : (
                  <ImageChange />
                )}
              </span>

              <div className='d-flex justify-content-between'>
                <Radio.Group
                  defaultValue={returnFlight}
                  value={returnFlight}
                  onChange={onChangeTrip}
                >
                  <Radio value="oneWay">One Way</Radio>
                  <Radio value="roundTrip">Round Trip</Radio>
                </Radio.Group>
              </div>

              <Divider />

              {(returnFlight === "roundTrip" || returnFlight === "oneWay") && (
                <SearchBar
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  selectedReturnDate={selectedReturnDate}
                  setSelectedReturnDate={setSelectedReturnDate}
                  crossReturnDate={crossReturnDate}
                  setReturnFlightComp={setReturnFlightComp}
                  returnFlightComp={returnFlightComp}
                  selectAdults={selectAdults}
                  setSelectAdults={setSelectAdults}
                  selectchildren={selectchildren}
                  setSelectchildren={setSelectchildren}
                  selectInfants={selectInfants}
                  setSelectInfants={setSelectInfants}
                  setReturnFlight={setReturnFlight}
                  returnFlight={returnFlight}
                  removeAdults={removeAdults}
                  addAdults={addAdults}
                  removeInfants={removeInfants}
                  addInfants={addInfants}
                  infantsError={infantsError}
                  removeChildern={removeChildern}
                  addChildern={addChildern}
                  roundTrip={roundTrip}
                  seatType={seatType}
                  setSeatType={setSeatType}
                  findDay={findDay}
                  setFindDay={setFindDay}
                  findDayRetrun={findDayRetrun}
                  setFindDayRetrun={setFindDayRetrun}
                  dateFormat={dateFormat}
                  showPrevDateIcon={showPrevDateIcon}
                  setShowPrevDateIcon={setShowPrevDateIcon}
                  currentFormattedDate={currentFormattedDate}
                  setTopCityData={setTopCityData}
                  topCityData={topCityData}

                  errorSameCitySelect={errorSameCitySelect}
                  setErrorSameCitySelect={setErrorSameCitySelect}
                  selectedFrom={selectedFrom}
                  setSelectedFrom={setSelectedFrom}
                  selectedTo={selectedTo}
                  setSelectedTo={setSelectedTo}
                  showSearchListFrom={showSearchListFrom}
                  setShowSearchListFrom={setShowSearchListFrom}
                  showSearchListTo={showSearchListTo}
                  handleSelectFromFlight={handleSelectFromFlight}
                  handleSelectToFlight={handleSelectToFlight}
                  setShowSearchListTo={setShowSearchListTo}

                  isReturnDrawerOpen={isReturnDrawerOpen}
                  setIsReturnDrawerOpen={setIsReturnDrawerOpen}
                  isDrawerOpen={isDrawerOpen}
                  setIsDrawerOpen={setIsDrawerOpen}

                  searchTermFrom={searchTermFrom}
                  setSearchTermFrom={setSearchTermFrom}
                  searchTermTo={searchTermTo}
                  setSearchTermTo={setSearchTermTo}

                  validationError={validationError}
                  fieldErrors={fieldErrors}
                />
              )}

              <div className='text-center'>
                {returnFlight === "oneWay" ? (
                  <Button type="primary" onClick={fetchOneWayFlight} disabled={infantsError} aria-label="search flights">Search  Flights</Button>
                ) : (returnFlight === "roundTrip" && (
                  <Button type="primary" onClick={fetchRoundCityFlights} disabled={infantsError} aria-label="Search roundtrip flights">Search Flights</Button>)
                )}
              </div>

            </Card>
          </Row>
        </div>
      </div>
    </section >
  );
};

export default SearchFlights;